module.exports = __webpack_public_path__ + "img/idle.827d148d.png";